import React, { FC, Suspense } from 'react';
import { PermissionSetType } from 'api/models';
import { PageLoading } from 'components/atoms/loading';
import { useUserPermissionSetType } from 'hooks/permissions';
import { useIsKnowledgeBaseFeatureEnabled } from 'hooks/use-knowledge-base-feature';
import { useIsScarletFeatureEnabled } from 'hooks/use-scarlet-feature';
import { NotFound } from 'routes/404';

export const ScarletFeatureWrapper: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const isScarletEnabled = useIsScarletFeatureEnabled();

  if (!isScarletEnabled) {
    return <NotFound />;
  }

  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
};

export const KnowledgeBaseFeatureWrapper: FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const isKnowledgeBaseEnabled = useIsKnowledgeBaseFeatureEnabled();
  const currentUserPermissionSetType = useUserPermissionSetType();
  const isAccountAdmin =
    currentUserPermissionSetType === PermissionSetType.AccountAdmin;

  if (!isKnowledgeBaseEnabled || !isAccountAdmin) {
    return <NotFound />;
  }

  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
};
